<main data-aos="fade-in">
    <h1 i18n="@@Biography title">Biography</h1>
    <div class="section" data-aos="section" data-aos-anchor-placement="center-top">
        <div id="trigger"></div>
        <div class="photo photo-bio" data-aos="photo"  data-aos-duration="3000" data-aos-anchor-placement="top-top" data-aos-anchor="#trigger"></div>
        <div class="intro bio"  data-aos="text" data-aos-anchor-placement="top-top" data-aos-anchor="#trigger"data-aos-duration="3000">
        <p i18n="@@bio-first-paragraph"><span >P</span>etar Đorđević was born in 1943 in Pirot.
            He finished primary school in Pirot and secondary in Art school in Nis.</p>
        <p i18n="@@bio-second-paragraph">
            He graduated from the Academy of Fine Arts in Belgrade in 1969 in the class of Professor Ljubica Cuca Sokić and completed his postgraduate studies at the same faculty in 1972.</p>

        <p i18n="@@bio-third-paragraph">
            He exhibited his works for the first time in 1966 in Belgrade.
            He has been a member of ULUS artists' association since 1970.
            As a freelance artist, he has exhibited in several solo and group exhibitions in the country and abroad.
        </p>
        <p i18n="@@bio-fourth-paragraph">
            From 1972 to 1975, Đorđević stayed in Paris, where he presented his work to the international public. He participated in the prestigious May Salon in Paris, with the painting "At the crossing" in 1973.
        </p>
        <p i18n="@@bio-fifth-paragraph">
            He was also engaged in pedagogical work, as a professor at the College of Vocational Studies for the Education of Educators.
            He lives and works in Pirot.
        </p>
       
        </div>
        </div>
        <div id="trigger1"></div>
        
        <div class="section"data-aos="section" data-aos-anchor-placement="center-top">
            <div class="photo photo-solo invisible"></div>
            
        <div class="solo bio" data-aos="text" data-aos-anchor-placement="top-center" data-aos-anchor="#trigger1"data-aos-duration="3000">
        <h3 i18n="@@sub-title-solo">Solo exhibitions</h3>
        <ul>
            <li i18n="@@1967">1967 - Pirot, National Library</li>
            <li i18n="@@1969">1969 - Belgrade, Gallery of Kolarac People's University</li>
            <li i18n="@@1976">1976 - Belgrade, Cultural Centre of Belgrade Gallery</li>
            <li i18n="@@1980">1980 - Berlin, Milan Art Gallery</li>
            <li i18n="@@1983">1983 - Pirot, Cultural Centre</li>
            <li i18n="@@1992">1992 - Belgrade, ULUS Gallery</li>
            <li i18n="@@1993">1993 - Nis, Gallery of Contemporary Art</li>
            <li i18n="@@1993-1">1993 - Pirot, Pirot Gallery</li>
            <li i18n="@@1996">1996 - Sofia, National History Museum</li>
            <li i18n="@@1998">1998 - Sombor, Cultural Centre Laza Kostić</li>
            <li i18n="@@2000">2000 - Pirot, Gallery Čedomir Krstić</li>
            <li i18n="@@2004">2004 - Leskovac, National Museum</li>
            <li i18n="@@2005">2005 - Belgrade, ULUS Gallery</li>
            <li i18n="@@2005-1">2005 - Novi Sad,Serbian Academy of Sciences and Arts Gallery</li>
            <li i18n="@@2012">2012 - Nis, Gallery of Contemporary Art</li>
            <li i18n="@@2019">2019 - Pirot,Gallery Čedomir Krstić </li>
        </ul>
        </div>
        
        <div class="photo photo-solo visible" data-aos="photo1"  data-aos-duration="3000" data-aos-anchor-placement="top-center" data-aos-anchor="#trigger1"></div>
        </div>
        <div class="section"data-aos="section" data-aos-anchor-placement="center-top">
        <div class="photo photo-group" data-aos="photo2"  data-aos-duration="3000" data-aos-anchor-placement="center-bottom" data-aos-anchor="#trigger2"></div>
        <div class="group bio" data-aos="text" data-aos-anchor-placement="top-center" data-aos-anchor="#trigger2"data-aos-duration="3000">
        <h3 i18n="@@sub-title-group">
            Some of his group exhibitions</h3>
        <ul>
            <li i18n="@@1966-group">1966 - Belgrade, Faculty of Fine Arts Student Exhibition</li>
            <li i18n="@@1968-group">1968 - Belgrade October Salon</li>
            <li i18n="@@1970-group">1970 - Belgrade,Contemporary Art Museum, Young '70,</li>
            <li i18n="@@1973-group">1973 - Paris, May Salon</li>
            <li i18n="@@1975-group">1975 - Perpignan,American Hyperrealism and European Realism</li>
            <li i18n="@@1977-group">1977 - Belgrade, Yugoslav Art Triennale</li>
            <li i18n="@@1979-group">1979 - Belgrade, Spring ULUS Exhibition</li>
            <li i18n="@@1979-1-group">1979 - Berlin, Group Exhibition</li>
            <li i18n="@@1981-group">1981 - Porec, XXI Annale , Art and City</li>
            <li i18n="@@1985-group">1985 - Belgrade, October Salon</li>
            <li i18n="@@1987-group">1987 - Berlin, Milan Gallery,Exhibition of Yugoslavian Painters</li>
            <li i18n="@@1989-group">1989 - Gornji Milanovac, Biennale of Miniature Art</li>
            <li i18n="@@1994-group">1994 - Prijepolje, Art Collony in Mileseva</li>
            <li i18n="@@1997-group">1997 - Toronto, International Biennale of Miniature Art</li>
            <li i18n="@@2003-group">2003 - Nis,ULUS Southeastern Serbia Exhibition</li>

        </ul>
        </div>
        <div id="trigger2"></div>
        </div>
        <div class="section"data-aos="section" data-aos-anchor-placement="center-top">
            <div class="photo photo-rewards invisible"></div>
        <div class="rewards bio" data-aos="text1" data-aos-anchor-placement="top-bottom" data-aos-anchor="#trigger3"data-aos-duration="3000">

        
        <p i18n="@@awards">
            <span>A</span>s a sign of recognition for his artwork, Petar Đorđević's paintings are in the permanent exhibition of the Museum of Contemporary Art in Belgrade and in numerous private collections in the country and abroad.
            He has won several awards for his artistic work.
        </p>
        <div class="rectangle" data-aos-duration="2500" data-aos="grow"></div>
        <div id="trigger3"></div>
        </div>
       
        <div class="photo photo-rewards visible" data-aos="photo1"  data-aos-duration="3000" data-aos-anchor-placement="top-bottom" data-aos-anchor="#trigger3"></div>
        
        </div>
   
</main>